<template>
    <div class="searchbar">
        <input type="text"
            class="in-search"
            :placeholder="placeholder"
            v-model="searchTxt"
            v-on:keyup.enter.stop="doSearch"/>

        <a href="javascript:void(0);" class="icon-search" id="btn_search" v-on:click="doSearch"></a>
    </div>
</template>

<script>
export default {
    name: 'insearch',

    data: () => ({
        searchTxt: ''
    }),

    props: {
        placeholder: {
            type: String,
            default: 'Search Templates'
        }
    },

    created() {
        VEvts.$on('CLEAR_SEARCH', () => {
            this.searchTxt = '';
        });
    },

    methods: {
        doSearch() {
            this.$emit('insearch', encodeURIComponent(this.searchTxt));
            VEvts.$emit('SEARCH_TEMPLATES');
        }
    }
}
</script>

<style>
.searchbar {
    position: relative;
    display: inline-block;
    vertical-align: middle;
    width: 290px;
}
.in-search {
    width: 290px;
    height: 30px;
    padding-left: 30px;
    color: #424242;
    border: 1px solid #c9caca;
    box-sizing: border-box;
}
.icon-search {
    position: absolute;
    top: 7px;
    left: 6px;
    width: 16px;
    height: 16px;
    background-image: url(../../assets/images/icon_common.png);
    background-repeat: no-repeat;
    background-position: -240px -5px;
}
</style>


// WEBPACK FOOTER //
// InSearch.vue?399bc06a